import { Component, OnInit, TemplateRef } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { ConstantsService } from '../services/constants.service';
import { environment } from "../../environments/environment"
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Auth, Storage } from 'aws-amplify';
import { ActivatedRoute, Router } from '@angular/router';
import { CacheService } from '../services/cache.service';
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';
import { startWith } from 'rxjs/operators';
import { SpinnerService } from '../services/spinner.service';
import Player from '@vimeo/player';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-pending',
  templateUrl: './admin-pending.component.html',
  styleUrls: ['./admin-pending.component.scss']
})
export class AdminPendingComponent implements OnInit {
  public isLoading = false;
  public isdisabled = false;
  public isProcessing = false;
  public folderName = this.constants.STATUS_TXT.PENDING_TXT;
  public currentUrl;
  public currentVideoTitle;
  public curentVideo;
  public currentIndex = 0;
  public videos = [];
  public animalsActive = false;
  public rainActive = false;
  public snowActive = false;
  public natureActive = false;
  public cityActive = false;
  public nightActive = false;
  public dayActive = false;
  public interiorActive = false
  public waterActive = false;
  public disableEdit = true;
  public skeltonArray;
  public prevDisable = false
  public nextDisable = false
  public urlPrefix = environment.S3_URL_PRFIX;
  public CurrentNickName = ""
  public currentLocation = ""
  public currentCountry = ""
  public currentVideoName = ""
  public isEditProcessing = false;
  currentAuthUser
  userName;
  videoName;
  nickname;
  cityLocation;
  country
  message
  count = 0;
  declineMessage;
  titleEdit: UntypedFormGroup;
  isDeclining
  p: number = 1;
  videoTitle: any;
  dateRecording: any;
  timeRecording: any;
  dateRecordingData: any;
  showErrorMessage= false;
  player = null;
  url1:string;
  url2:string;
  deleteSelectedVideoName = null;
  isNameUpdate = false;
  isVimeoProcessing = false;
  isSearchResult = false;
  firstIndex;
  lastIndex;
  currentPageVideos; 
  videosToFetch = [];
  isApproving = false;
  pendingVideosSubscription: Subscription;
  itemsPerPage: number = 10;
  constructor(
    public constants: ConstantsService,
    private adminservice: AdminService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private authenticate: CacheService,
    private dataService: DataService,
    private urlConstants: UrlConstants,
    private spinner: SpinnerService,
    public dialog: MatDialog
  ) {
    var skelton = [
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG
    ]
    this.skeltonArray = skelton;
  }

  async ngOnInit() {
    this.authUser();
    this.isLoading = true;
    this.isdisabled = true;
    this.isProcessing = true;
    await this.load();
  }

  ngOnDestroy() {
    if (this.pendingVideosSubscription) {
      this.pendingVideosSubscription.unsubscribe();
    }
  }

  async authUser() {
    this.authenticate.getAuthUser()
      .then(data => {
        let { userName, login } = data
        this.userName = userName
        if (!login) {
          this.router.navigate(['/login'])
        }
        this.spinner.hide()
      })
    this.spinner.hide()
  }
  load = async () => {
    let pendingVideos
    this.initialiaseFrom()
    this.initialiaseTitleFrom()
    this.adminservice.getVideoList(this.constants.STATUS_TXT.SUCCESS)
    if(this.pendingVideosSubscription){
      this.pendingVideosSubscription.unsubscribe();
    }
    this.pendingVideosSubscription = this.adminservice.cast.subscribe(async (data) => {
      this.videos = data["Items"]
      if (data["Items"]?.length !== 0) {
        this.videos?.forEach(element => {
           element.isDeleting = false;
        });
        this.fetchThumbnailsAndUpdateVideoStatus();
        this.assignValue(this.videos, this.currentIndex);
        this.isLoading = false;
        this.isProcessing = false;
      }
      else {
        this.isLoading = false;
        this.isProcessing = false;
      }
    })
  }
  async getFileDetails(video) {
    try {
      const blob = await fetch(video.url).then(r => r.blob());
      video.showErrorMessage = blob.size <= 10 || blob.type === 'application/xml';   
    } catch (error) {
      console.error('Error fetching the file:', error);
    }
  }
  assignValue(videos, index) {

    this.currentVideoTitle = videos[index].videoTitle;
    this.curentVideo = videos[index].videoName;
    this.CurrentNickName = videos[index].nickName;
    this.currentLocation = videos[index].cityLocation;
    this.currentCountry = videos[index].country;
    this.currentVideoName = videos[index].videoName;
    this.currentUrl = videos[index].url;
    this.dateRecording = videos[index].dateRecording;
    this.timeRecording = videos[index].timeRecording;
    this.url1 = videos[index].videoUrl.split('/')[3];
    this.url2 = videos[index].videoUrl.split('/')[4];
    let id = videos[index].videoName;
    if (videos[index].tag.Animals) {
      this.animalsActive = true;
    }
    if (videos[index].tag.Snow) {
      this.snowActive = true;
    }
    if (videos[index].tag.City) {
      this.cityActive = true;
    }
    if (videos[index].tag.Nature) {
      this.natureActive = true;
    }
    if (videos[index].tag.Rain) {
      this.rainActive = true;
    }
    if (videos[index].tag.Night) {
      this.nightActive = true;
    }
    if (videos[index].tag.Day) {
      this.dayActive = true;
    }
    if (videos[index].tag.Interior) {
      this.interiorActive = true;
    }
    if (videos[index].tag.Water) {
      this.waterActive = true;
    }
    if(this.isNameUpdate){
      this.isNameUpdate = false;
      return;
    }
    this.initPlayer();
  }
  Search() {
    if (this.videoTitle === "") {
      this.isSearchResult = false;
      this.load();
      this.isLoading = true;
    }
    else {
      this.isSearchResult = true;
      if(this.player){
        this.player.destroy();
      }
      if(this.videos.length>0){
        this.videos = this.videos.filter(res => {
          return res.videoTitle.toLowerCase().match(this.videoTitle.toLowerCase());
        })
      }
      if (this.videos.length == 0) {
        this.clearCurrentVideo();
      }
    }
  }
  clearCurrentVideo() {
    this.curentVideo = "";
        this.currentVideoTitle = "";
        this.CurrentNickName = "";
        this.currentLocation = "";
        this.currentCountry = "";
        this.currentVideoName = "";
        this.currentUrl = "";
        this.dateRecording = "";
        this.timeRecording = "";
        this.url1 = "";
        this.url2 = "";
        this.makeDisable();
  }
  openDialog(templateRef: TemplateRef<any>, videoName) {
    this.deleteSelectedVideoName = videoName;
    this.dialog.open(templateRef, {
      panelClass: 'admin-dialog'
    });
  }

  async onClickDelete() {
    document.getElementById(this.deleteSelectedVideoName).style.opacity = "50%";
    this.videos = this.videos.map(video =>
      video.videoName === this.deleteSelectedVideoName ? { ...video, isDeleting: true } : video
    );
    await this.deleteVideo(this.deleteSelectedVideoName);
  }

  async deleteVideo(videoName) {
    const index = this.videos.findIndex(video => video.videoName === this.deleteSelectedVideoName);
    if (index == -1)
      return
    this.isProcessing = true;
    const params = [
      { param: '{object}', value: "submit" },
    ];
    const bodyObj = {
      "commonKey": this.constants.VIDEO_COMMON_KEY,
      "videoName": videoName,
      "vimeoToken": this.videos[index].vimeoToken,
      "videoUrl": this.videos[index].videoUrl
    }
    this.dataService.postData(this.urlConstants.getUri(this.urlConstants.deleteItem, params), JSON.stringify(bodyObj)).subscribe({
      next: (data: any) => {
        this.isProcessing = false;
        this.videos.splice(index, 1);
        if (this.videos.length < 1) {
          this.player.destroy()
        } else if (this.currentIndex == index) {
          this.onclickRow(this.videos[0]);
          this.p = 1;
        }
        this.deleteSelectedVideoName = null;
      },
      error: (err) => {
        console.error('Error deleting video:', err);
        // Optional: Notify user/admin
        this.videos[index].isDeleting = false;
        this.deleteSelectedVideoName = null;
        this.isProcessing = false;
      }
    })
  }

  initialiaseTitleFrom(): void {
    this.titleEdit = this.fb.group({
      nickName: new UntypedFormControl(this.CurrentNickName),
      location: new UntypedFormControl(this.currentLocation),
      country: new UntypedFormControl(this.currentCountry),
      tags: this.fb.group({
        Animals: this.animalsActive,
        Rain: this.rainActive,
        Snow: this.snowActive,
        City: this.cityActive,
        Nature: this.natureActive,
        Night: this.nightActive,
        Day: this.dayActive,
        Interior: this.interiorActive,
        Water: this.waterActive
      }),
    })
  }
  onClickEdit(event) {
    document.getElementById("edit-form").style.display = 'flex'
    document.getElementById("title-container").style.display = this.constants.NONE_TXT
    document.getElementById("tag-container").style.display = this.constants.NONE_TXT
    this.initialiaseTitleFrom()
  }
  onClickDone(event) {
    this.isEditProcessing = true
    if (this.curentVideo === "") {
      this.isEditProcessing = false;
      document.getElementById("error-message").innerHTML = this.constants.SELECT_VIDEO_TXT
      document.getElementById("error-alert").style.display = this.constants.BLOCK_TXT
    } else {
      this.isProcessing = true;
      var updatedNickname = this.titleEdit.value.nickName;
      var updatedLocation = this.titleEdit.value.location;
      var updatedCountry = this.titleEdit.value.country;
      var tags = this.titleEdit.value.tags;
      var updatedTitle;
      var videoName = this.currentVideoName;
      updatedTitle = `${updatedNickname} - ${updatedLocation}, ${updatedCountry}`;
      let attributes = [{
        videoName: videoName,
        commonKey: this.constants.VIDEO_COMMON_KEY,
        updatedNickname: updatedNickname,
        updatedLocation: updatedLocation,
        updatedCountry: updatedCountry,
        updatedTitle: updatedTitle,
        otherStatus: "nameUpdate",
        tags: tags
      }];
      console.log("videoName", videoName);
      this.adminservice.EditName(attributes)
        .then(data => {
          this.isProcessing = false;
          this.makeDisable()
          let index = this.videos.findIndex(video => video.videoName == videoName)
          if (index !== -1) {
            this.videos[index].nickName = updatedNickname;
            this.videos[index].cityLocation = updatedLocation;
            this.videos[index].country = updatedCountry;
            this.videos[index].videoTitle = updatedTitle;
            this.videos[index].tag = tags;
            this.isNameUpdate = true;
            this.assignValue(this.videos, this.currentIndex)
          }
          // this.adminservice.getVideoList(this.constants.STATUS_TXT.SUCCESS)
          document.getElementById("edit-form").style.display = this.constants.NONE_TXT
          document.getElementById("title-container").style.display = 'flex'
          document.getElementById("tag-container").style.display = 'flex'
          this.isEditProcessing = false;
        })
        .catch(error => {
          this.isEditProcessing = false;
          this.isProcessing = false;
        }
        )
    }
  }
  onClickCancel(event) {
    document.getElementById("edit-form").style.display = this.constants.NONE_TXT
    document.getElementById("title-container").style.display = 'flex'
    document.getElementById("tag-container").style.display = 'flex'
    this.titleEdit.value.nickName = this.CurrentNickName;
    this.titleEdit.value.location = this.currentLocation;
    this.titleEdit.value.country = this.currentCountry;
    this.initialiaseTitleFrom()
  }
  onClickNext() {
    this.initialiaseTitleFrom()
    if (this.currentIndex < this.videos.length - 1) {
      this.makeDisable();
      this.currentIndex = this.currentIndex + 1;
      this.prevDisable = false;
      this.assignValue(this.videos, this.currentIndex)

      // Update page number
      this.p = Math.floor(this.currentIndex / this.itemsPerPage) + 1;
    }
    else {
      this.nextDisable = true;
    }
  }
  onClickPrev() {
    this.initialiaseTitleFrom()
    if (this.currentIndex === 0) {
      this.prevDisable = true;
    }
    else {
      this.makeDisable();
      this.currentIndex = this.currentIndex - 1;
      this.nextDisable = false;
      this.assignValue(this.videos, this.currentIndex)

      // Update page number
      this.p = Math.floor(this.currentIndex / this.itemsPerPage) + 1;
    }
  }
  makeDisable() {
    this.animalsActive = false;
    this.snowActive = false;
    this.cityActive = false;
    this.natureActive = false;
    this.rainActive = false;
    this.nightActive = false;
    this.dayActive = false;
    this.interiorActive = false;
    this.waterActive = false;
  }
  copyEmail(video, event) {
    navigator.clipboard.writeText(video.emailId).then(() => {
      document.getElementById(`${event.target.id}`).innerHTML = "email copied"
    })
  }
  onClickCheck(event) {
    if (event.target.checked) {
      this.count = this.count + 1;
    }
    else {
      this.count = this.count - 1;
    }
    if (this.count === 0) {
      this.isdisabled = true;
    }
    else {
      this.isdisabled = false;
    }
  }
  async onClickApprove() {
    this.isProcessing = true;
    this.isApproving = true;
    let clickedVideoList = (this.videos.filter(s => s.videoName === this.curentVideo))
    if (this.curentVideo === "") {
      this.isProcessing = false;
      this.isApproving = false;
      document.getElementById("error-message").innerHTML = this.constants.SELECT_VIDEO_TXT
      document.getElementById("error-alert").style.display = this.constants.BLOCK_TXT
    }
    else {
      const index = this.videos.findIndex(video => video.videoName === this.currentVideoName);
      const dateStr =  clickedVideoList[0].dateRecording;
      this.videoName = clickedVideoList[0].videoName;
      var nickName = clickedVideoList[0].nickName;
      var cityLocation = clickedVideoList[0].cityLocation;   
      var timeRecording = clickedVideoList[0].timeRecording;
      var country = clickedVideoList[0].country;
      let attributes = [{
        "videoName": this.videoName,
        "commonKey": this.constants.VIDEO_COMMON_KEY,
        "videoStatus": this.constants.STATUS_TXT.UPLOADEDTOVIEO_TXT,
        "message": `${window.location.origin}/share.html?id=`,
        "nickName": nickName,
        "cityLocation": cityLocation,
        "country": country,
        "dateRecording" : dateStr, 
        "timeRecording" : timeRecording,
        "videoFolder" : clickedVideoList[0].videoFolder,
        "videoUrl" : clickedVideoList[0].videoUrl,
        "emailId": clickedVideoList[0].emailId,
        "tag": clickedVideoList[0].tag,
        "thumbnail":clickedVideoList[0].thumbnail,
        "stats": clickedVideoList[0].stats
      }]

      this.adminservice.updateSubmit(attributes)
        .then(data => {
          this.curentVideo = '';
          this.isProcessing = false;
          this.isApproving = false;
          document.getElementById("videoTitle").innerHTML = `${clickedVideoList[0].videoTitle} `;
          document.getElementById("message").innerHTML = this.constants.VIDEO_APPROVED_TXT;
          document.getElementById("success-alert").style.display = this.constants.BLOCK_TXT;
          // this.adminservice.getVideoList(this.constants.STATUS_TXT.PENDING_TXT)
          this.videos.splice(index, 1);
        if (this.videos.length < 1) {
          this.player.destroy()
          this.clearCurrentVideo();
        } else if (this.currentIndex == index) {
          this.onclickRow(this.videos[0]);
          this.p = 1;
        }
          setTimeout(function () {
            document.getElementById("success-alert").style.display = 'none'
          }, 5000);
        })
        .catch(error => {
          if (error.message != this.constants.TIMEOUT_ERROR_TXT) {
            document.getElementById("error-alert").style.display = this.constants.BLOCK_TXT
            document.getElementById("error-message").innerHTML = `${error.error.msg}`
            this.isProcessing = false;
            this.isApproving = false;
            setTimeout(function () {
              document.getElementById("error-alert").style.display = 'none'
            }, 5000);
          }
          else {
            this.curentVideo = '';
            this.isProcessing = false;
            this.isApproving = false;
            document.getElementById(this.videoName).style.display = this.constants.NONE_TXT
            document.getElementById("videoTitle").innerHTML = `${clickedVideoList[0].videoTitle} `;
            document.getElementById("message").innerHTML = this.constants.VIDEO_APPROVED_TXT;
            document.getElementById("success-alert").style.display = this.constants.BLOCK_TXT
            setTimeout(function () {
              document.getElementById("success-alert").style.display = 'none'
            }, 10000);
          }
        })
    }
  }
  initialiaseFrom(): void {
    this.declineMessage = this.fb.group({
      0: new UntypedFormControl(false),
      1: new UntypedFormControl(false),
      2: new UntypedFormControl(false),
      3: new UntypedFormControl(false),
      4: new UntypedFormControl(false),
      5: new UntypedFormControl(false),
      6: new UntypedFormControl(false),
      custom: new UntypedFormControl(""),
    })
  }
  async onClickReject(event) {
    this.isDeclining = true;
    this.isProcessing = true;
    var message0 = "";
    var message1 = "";
    var message2 = "";
    var message3 = "";
    var message4 = "";
    var message5 = "";
    var message6 = "";
    var message = "";
    event.preventDefault
    for (let values in this.declineMessage.value) {
      if (values === '0' && this.declineMessage.value[values] === true) {
        message0 = `${this.constants.REJECT_REASON_1_TXT}, `;
      }
      if (values === '1' && this.declineMessage.value[values] === true) {
        message1 = `${this.constants.REJECT_REASON_2_TXT}, `;
      }
      if (values === '2' && this.declineMessage.value[values] === true) {
        message2 = `${this.constants.REJECT_REASON_3_TXT}, `
      }
      if (values === '3' && this.declineMessage.value[values] === true) {
        message3 = `${this.constants.REJECT_REASON_4_TXT}, `;
      }
      if (values === '4' && this.declineMessage.value[values] === true) {
        message5 = `${this.constants.REJECT_REASON_6_TXT}, `;
      }
      if (values === '6' && this.declineMessage.value[values] === true) {
        message6 = `${this.constants.REJECT_REASON_7_TXT}, `;
      }
      if (values === 'custom' && this.declineMessage.value[values] !== "") {
        message = this.declineMessage.value[values];
      }
    }
    var declaineMessage = message0 + message1 + message2 + message3 + message4 + message5 + message6
    var otherMessage = message;
    let clickedVideoList = (this.videos.filter(s => s.videoName === this.curentVideo))
    if (this.curentVideo === "") {
      document.getElementById("error-alert").style.display = this.constants.BLOCK_TXT
      document.getElementById("error-message").innerHTML = this.constants.SELECT_VIDEO_TXT
      this.isDeclining = false
      this.isProcessing = false;
    }
    else {
      const index = this.videos.findIndex(video => video.videoName === this.currentVideoName);
      this.videoName = clickedVideoList[0].videoName;
      this.message = clickedVideoList[0].message;
      var nickName = clickedVideoList[0].nickName;
      var cityLocation = clickedVideoList[0].cityLocation;
      var country = clickedVideoList[0].country;
      var emailId = clickedVideoList[0].emailId;
      var dateRecording = clickedVideoList[0].dateRecording;
      var timeRecording = clickedVideoList[0].timeRecording;
      let attributes = [{
        "videoName": this.videoName,
        "commonKey": this.constants.VIDEO_COMMON_KEY,
        "videoStatus": this.constants.STATUS_TXT.REJECTED_TXT,
        "lastFolder": this.constants.STATUS_TXT.PENDING_TXT,
        "message": declaineMessage,
        "otherStatus": otherMessage,
        "nickName": nickName,
        "cityLocation": cityLocation,
        "country": country,
        "emailId": emailId,
        "dateRecording" : dateRecording,
        "timeRecording": timeRecording,
        "rejectionStatus": this.constants.REJECTION_IN_PROGRES,
        "videoFolder" : clickedVideoList[0].videoFolder,
        "vimeoToken": clickedVideoList[0].vimeoToken,
        "videoUrl" : clickedVideoList[0].videoUrl
      }]
      this.adminservice.updateSubmit(attributes)
        .then(data => {
          this.curentVideo = '';
          this.isDeclining = false;
          this.isProcessing = false;
          document.getElementById("videoTitle").innerHTML = `${clickedVideoList[0].videoTitle}`;
          document.getElementById("message").innerHTML = " Rejected successfully"
          document.getElementById("success-alert").style.display = this.constants.BLOCK_TXT
          // this.adminservice.getVideoList(this.constants.STATUS_TXT.PENDING_TXT)
          this.videos.splice(index, 1);
        if (this.videos.length < 1) {
          this.player.destroy()
          this.clearCurrentVideo();
        } else if (this.currentIndex == index) {
          this.onclickRow(this.videos[0]);
          this.p = 1;
        }
          this.onClosePopup()
          setTimeout(function () {
            document.getElementById("success-alert").style.display = 'none'
          }, 5000);
        })
        .catch(error => {
          if (error.message != "Http failure response for https://x45lddhmu1.execute-api.us-east-1.amazonaws.com/dev/update/submit: 0 Unknown Error") {
            document.getElementById("error-alert").style.display = this.constants.BLOCK_TXT
            document.getElementById("error-message").innerHTML = ` ${error.error.msg};
            }`
            this.isDeclining = false;
            this.isProcessing = false;
            this.onClosePopup()
            setTimeout(function () {
              document.getElementById("error-alert").style.display = 'none'
            }, 5000);
          }
          else {
            document.getElementById(this.videoName).style.display = this.constants.NONE_TXT
            document.getElementById("videoTitle").innerHTML = `${clickedVideoList[0].videoTitle}`;
            document.getElementById("message").innerHTML = " Rejected successfully"
            document.getElementById("success-alert").style.display = this.constants.BLOCK_TXT
            this.isDeclining = false;
            this.isProcessing = false;
            this.onClosePopup()
            setTimeout(function () {
              document.getElementById("success-alert").style.display = 'none'
            }, 10000);
          }
        })
    }
  }
  onclickRow(video) {
    if((video.videoName == this.currentVideoName  && !this.isSearchResult && !this.isVimeoProcessing) || this.isProcessing)
      return;
    document.getElementById("edit-form").style.display = this.constants.NONE_TXT
    document.getElementById("title-container").style.display = 'flex'
    document.getElementById("tag-container").style.display = 'flex'
    this.isVimeoProcessing = false;
    this.makeDisable()
    this.currentIndex = (this.videos.indexOf(video))
    if (this.currentIndex === 0) {
      this.prevDisable = true;
    }
    else {
      this.prevDisable = false;
    }
    if (this.currentIndex === this.videos.length - 1) {
      this.nextDisable = true;
    }
    else {
      this.nextDisable = false;
    }
    this.currentUrl = video.url;
    this.currentVideoTitle = video.videoTitle;
    this.curentVideo = video.videoName;
    this.CurrentNickName = video.nickName;
    this.currentLocation = video.cityLocation;
    this.currentCountry = video.country;
    this.currentVideoName = video.videoName;
    this.url1 = video.videoUrl.split('/')[3];
    this.url2 = video.videoUrl.split('/')[4];
  if(video.dateRecording !== undefined){
    this.dateRecording = video.dateRecording;
  }
  
    this.timeRecording = video.timeRecording
    if (video.tag.Animals) {
      this.animalsActive = true;
    }
    if (video.tag.Snow) {
      this.snowActive = true;
    }
    if (video.tag.City) {
      this.cityActive = true;
    }
    if (video.tag.Nature) {
      this.natureActive = true;
    }
    if (video.tag.Rain) {
      this.rainActive = true;
    }
    if (video.tag.Night) {
      this.nightActive = true;
    }
    if (video.tag.Day) {
      this.dayActive = true;
    }
    if (video.tag.Interior) {
      this.interiorActive = true;
    }
    if (video.tag.Water) {
      this.waterActive = true;
    }
    setTimeout(()=>{
      this.initPlayer();
      this.initialiaseTitleFrom()
    },0)
  }
  onClosePopup() {
    document.getElementById("confirm-button").style.display = "inline-flex"
    document.getElementById("close-button").style.display = this.constants.NONE_TXT;
    document.getElementById('modal-reject').style.display = this.constants.NONE_TXT
  }
  closeErrorAlert() {
    document.getElementById("error-alert").style.display = this.constants.NONE_TXT
  }
  closeSuccessAlert() {
    document.getElementById("videoTitle").innerHTML = "";
    document.getElementById("success-alert").style.display = this.constants.NONE_TXT
  }
  onClickDecline() {
    document.getElementById('modal-reject').style.display = this.constants.BLOCK_TXT
  }
  ClickModalReject() {
    document.getElementById("confirm-button").style.display = "inline-flex"
    document.getElementById("close-button").style.display = this.constants.NONE_TXT;
    document.getElementById('modal-reject').style.display = this.constants.NONE_TXT
  }
  onClickName(video) {
    let email = video.emailId
    let Name = video.creatorName;
    let memberId = video.memberId;
    let profilePicture = video.profilePicture;
    let data = {
      email: email,
      name: Name,
      memberId: memberId,
      profilePicture: profilePicture
    }
    this.adminservice.shareUserData(data);
    this.router.navigate(['./user'])
  }

  initPlayer = async () => {
    if(this.player){
      await this.player.destroy();
    }
    this.isVimeoProcessing = false;
    setTimeout(async()=>{
      this.player = await new Player('video-player', {
        url: `https://player.vimeo.com/video/${this.url1}?h=${this.url2}`,
        autoplay: true,
        autopause: false,
        muted: true,
        height: 510, // enable this if we need videofull screen
        controls: true,
        loop: true
      })
      this.player.ready().catch((error) => {
        this.isVimeoProcessing = true;
        console.log("****PLAYER ERROR**** INIT FAILURE :",error);
      });
    },0)
  }

  onPageChange(event) {
    this.p = event;
    console.log("pageChange triggered");
    if (!this.isSearchResult) {
      this.fetchThumbnailsAndUpdateVideoStatus();
    }
  }

  fetchThumbnailsAndUpdateVideoStatus() {
    this.firstIndex = (this.p * 10) - 10
    this.lastIndex = (this.p * 10)
    this.currentPageVideos = this.videos.slice(this.firstIndex, this.lastIndex);
    this.videosToFetch = this.currentPageVideos.filter((video) => {
      return video.thumbnail == this.constants.VIMEO_DEFAULT_THUMBNAIL
    })
    if (this.videosToFetch.length > 0) {
      const params = [
        { param: '{actionName}', value: 'updateThumbs' }
      ]
      const postdata = {
        "videosToFetch": this.videosToFetch
      }
      this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata).subscribe((data: any) => {
        if (data.status === 'success' && data.response?.updatedVideos) {
          const updatedVideos = data.response.updatedVideos;
          
          // Process updates and removals
          updatedVideos.forEach((updatedVideo: any) => {
            const videoName = updatedVideo.videoName;
            const videoStatus = updatedVideo.updatedData?.finalStatus;
            const videoIndex = this.videos.findIndex((video: any) => video.videoName === videoName);
            
            if (videoStatus === 'failed' && videoIndex !== -1) {
              // Remove failed videos
              this.videos.splice(videoIndex, 1);
            } else if (videoStatus !== 'failed') {
              // Update existing or add new videos
              if (videoIndex !== -1) {
                this.videos[videoIndex] = { ...this.videos[videoIndex], ...updatedVideo.updatedData };
              }
            }
          });
        }

      }, (error) => {
        console.log("Error in fetching thumbnails", error);
      })
    }
  }

  getAbsoluteIndex(pageIndex: number): number {
    return (this.p - 1) * this.itemsPerPage + pageIndex; // assuming itemsPerPage = 10
  }

  openApproveDialog(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'admin-dialog'
    });
  }
}
